<template>
  <footer class="bg-dark-light py-3 px-6 text-center text-text-secondary text-sm datav-border">
    <p>© 2025 动环监控系统 | 版本号: v2.5.0</p>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
};
</script>

<style lang="scss" scoped>
.datav-border {
  border: 1px solid rgba(22, 93, 255, 0.3);
  box-shadow: 0 0 15px rgba(22, 93, 255, 0.1);
}

.bg-dark-light {
  background-color: #1d2129;
}

.text-text-secondary {
  color: #86909C;
}
</style>